/* eslint-disable css-modules/no-undef-class */
import Image from '@/components/atoms/image/image';
import Youtube from '@/components/molecules/youtube/youtube';
import { getYoutubeId } from '@/libraries/getters/get-youtube-id';
import styles from './media-lightbox-item.module.scss';

export interface MediaLightboxItemProps {
  /** The item to display. */
  item: Content.Properties.ImageAndVideoGridItem;
  /** Prefetch the item. */
  preload: boolean;
}

const MediaLightboxItem = ({ item, preload }: MediaLightboxItemProps) => {
  const isVideo = 'video' in item;

  return (
    <div key={item.id} className={styles.component}>
      <div className={styles.wrapper}>
        {isVideo ? (
          <Youtube
            className={styles.video}
            videoId={getYoutubeId(item.video.url)}
          />
        ) : (
          <Image
            alt={item.image.altText}
            className={styles.image}
            fill
            objectfit="contain"
            priority={preload}
            src={item.image.url}
            srcSet={{
              desktop: {
                width: 1051,
              },
              laptop: {
                width: 565,
              },
              tablet: {
                width: 656,
              },
            }}
            unoptimized
            width={311}
          />
        )}
      </div>
    </div>
  );
};

MediaLightboxItem.displayName = 'MediaLightboxItem';

export default MediaLightboxItem;
